<template>
  <BaseIdCard :numberPerRow="5" :border="props.typeFilament.estDefaut ? 'border-b-[#00ff00]' : 'border-b-[#ff0000]'">
    <div class="flex flex-row justify-center">
      <SimpleText :content="props.typeFilament.libelle" v-show="!isEditing"/>
    </div>
    <InputField :placeholder="t('label')" showLabel v-model="editLibelle" v-show="isEditing" />

    <BaseKeyValue :cles="t('priceKg')" v-show="!isEditing">
      <SimpleText :content="props.typeFilament.prixKg + '€'"/>
    </BaseKeyValue>
    <InputField :placeholder="t('priceKg')" type="number" showLabel v-model="editPrixKg" v-show="isEditing" />

    <InputField :placeholder="t('isDefault')" type="checkbox" showLabel v-model="editEstDefaut"  v-show="isEditing" />

    <div class="mt-4 flex flex-row gap-2 justify-end">
      <GreenCheckIcon v-show="isEditing" @click="onEdit" />
      <OrangeEditIcon v-show="!isEditing" @click="() => {isEditing = true;}" />
      <RedTrashIcon @click="onDelete" />
    </div>
  </BaseIdCard>
</template>

<script setup>

import {t} from "@/utils/Traduction";
import {defineProps, ref, watch} from 'vue';
import {NotificationStores} from "@/stores/NotificationStores";
import {TypeFilamentStore} from "@/stores/TypeFilamentStore";
import GreenCheckIcon from "@/components/atoms/GreenCheckIcon.vue";
import OrangeEditIcon from "@/components/atoms/OrangeEditIcon.vue";
import RedTrashIcon from "@/components/atoms/RedTrashIcon.vue";
import BaseIdCard from "@/components/molecules/BaseIdCard.vue";
import SimpleText from "@/components/atoms/SimpleText.vue";
import InputField from "@/components/molecules/InputField.vue";
import BaseKeyValue from "@/components/molecules/BaseKeyValue.vue";

const props = defineProps({
  typeFilament: Object,
  showModalDelete: Function
});

const notificationStores = NotificationStores();
const typeFilamentStore = TypeFilamentStore();

const isEditing = ref(false);
const editLibelle = ref(props.typeFilament.libelle);
const editPrixKg = ref(props.typeFilament.prixKg);
const editEstDefaut = ref(props.typeFilament.estDefaut);

watch(() => props.typeFilament.estDefaut, (newValue) => {
  editEstDefaut.value = newValue;
}, { immediate: true });

const onDelete = () => {
  props.showModalDelete(props.typeFilament.uuid);
}

const onEdit = () => {
  if(editLibelle.value === "" || editPrixKg.value === "" || editPrixKg.value < 0) {
    notificationStores.addNotification(t("needFillAllFields"), 'error');
    return;
  }

  typeFilamentStore.editTypeFilament(editLibelle.value, editPrixKg.value, editEstDefaut.value, props.typeFilament.uuid);
  isEditing.value = false;
}

</script>

<style scoped>

</style>